import './App.css';
import React from "react";
import {Navbar, Footer} from "./components/common";
import {
    BrowserRouter as Router,
    Routes,
    Route,
} from "react-router-dom";
import {Home, Roadmap, Inserr, Contact, About, Tester, Ethics} from "./pages";
import ScrollToTop from './assets/js/scrollToTop';

function App() {
  return (
    <Router>
      <ScrollToTop/>
      <Navbar/>
      <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="/about" element={<About/>}/>
        <Route path="/roadmap" element={<Roadmap/>}/>
        <Route path="/inserr" element={<Inserr/>}/>
        <Route path="/contact" element={<Contact/>}/>
        <Route path="/ethics" element={<Ethics/>}/>
        <Route path="/Tester" element={<Tester/>}/>
      </Routes>
      <Footer/>
    </Router>
  );
}

export default App;
